/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatpresetinstagramportrait3Inputs */

const en_formatpresetinstagramportrait3 = /** @type {(inputs: Formatpresetinstagramportrait3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram Portrait`)
};

const de_formatpresetinstagramportrait3 = /** @type {(inputs: Formatpresetinstagramportrait3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram Hochformat`)
};

/**
* | output |
* | --- |
* | "Instagram Portrait" |
*
* @param {Formatpresetinstagramportrait3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const formatpresetinstagramportrait3 = /** @type {((inputs?: Formatpresetinstagramportrait3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatpresetinstagramportrait3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatpresetinstagramportrait3(inputs)
	return de_formatpresetinstagramportrait3(inputs)
});
export { formatpresetinstagramportrait3 as "formatPresetInstagramPortrait" }